'use client'
import * as React from 'react'
import { UserProfilePanel } from '../user-profile-panel'

interface LeftSidebarProps {
  slug?: string
  isSticky?: boolean
  isSubDetailSection?: boolean
  isShowFollowersCount?: boolean
}

export function LeftSidebar({
  slug,
  isSticky = true,
  isSubDetailSection,
  isShowFollowersCount,
}: LeftSidebarProps) {
  return isSticky ? (
    <LeftSidebarSticky
      slug={slug}
      isSubDetailSection={isSubDetailSection}
      isShowFollowersCount={isShowFollowersCount}
    />
  ) : (
    <LeftSidebarPlain
      slug={slug}
      isSubDetailSection={isSubDetailSection}
      isShowFollowersCount={isShowFollowersCount}
    />
  )
}

/** Sticky variant — safe hook usage */
function LeftSidebarSticky({
  slug,
  isSubDetailSection = false,
  isShowFollowersCount,
}: LeftSidebarProps) {
  return (
    <aside className="hidden w-[256px] shrink-0 lg:block self-stretch">
      <div
        className="
          sticky top-5
          max-h-[calc(100vh-20px)]
          overflow-auto
        "
      >
        <div className="flex w-[256px] flex-col gap-4">
          <UserProfilePanel
            slug={slug}
            isSubDetailSection={isSubDetailSection}
            isShowFollowersCount={isShowFollowersCount}
          />
        </div>
      </div>
    </aside>
  )
}

/** Non-sticky variant — no hook */
function LeftSidebarPlain({
  slug,
  isSubDetailSection = true,
  isShowFollowersCount,
}: LeftSidebarProps) {
  return (
    <div className="relative hidden w-[256px] shrink-0 self-stretch lg:block">
      <div className="flex w-[256px] flex-col gap-4">
        {/* {SOCIAL_FF_DIGEST_SIGNUP ? <DigestSignupPanel /> : null} */}
        <UserProfilePanel
          slug={slug}
          isSubDetailSection={isSubDetailSection}
          isShowFollowersCount={isShowFollowersCount}
        />
      </div>
    </div>
  )
}
